import { http } from "config/http";

export const permission = async (user:any) => {
    try {
        if(user !== 0){
            const res: any = await http.get(`get_permission_data?role_id=${user}&client_env=${localStorage.getItem("clientName")}`)
            return { result: res?.data }
        }else{
            const res: any = await http.get(`get_permission_data?client_env=${localStorage.getItem("clientName")}`)
            return { result: res?.data }
        }
    } catch (error: any) {
        return { error: error.message }
    }
}
export const permissionPut = async (data: any) => {
    try {
        const res: any = await http.put(`role_permissions`, { ...data, client_env: localStorage.getItem("clientName") })
        return { result: res?.data }
    } catch (error: any) {
        return { error: error.message }
    }
}